module.exports = __webpack_public_path__ + "static/media/utility_pole_metal.095de33a.png";